@if (allowMarkup) {
    <span class="title" [innerHTML]="title"></span>
}
@if (!allowMarkup) {
    <span class="title">{{ title }}</span>
}
